"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var findItem_1 = require("./findItem");
/**
 * This utility would return null if acceptedLanguages does not match eventLocales otherwise return matched locale.
 * @param eventLocales
 * @param acceptedLanguages
 */
var getLocale = function (eventLocales, acceptedLanguages) {
    var _a;
    var matchingLocale = null;
    var isEventMultiLingual = (eventLocales === null || eventLocales === void 0 ? void 0 : eventLocales.length) > 1;
    if (isEventMultiLingual) {
        // collect the browser locale
        var acceptedLocale = (_a = acceptedLanguages === null || acceptedLanguages === void 0 ? void 0 : acceptedLanguages.split(',')) === null || _a === void 0 ? void 0 : _a[0].toLowerCase();
        // Chinese for Taiwan, Hong Kong, and Macau map to Traditional
        acceptedLocale = /^zh-(?:tw|hk|mo)$/.test(acceptedLocale) ? 'zh-cht' : acceptedLocale;
        var localeParts = acceptedLocale === null || acceptedLocale === void 0 ? void 0 : acceptedLocale.split('-');
        if ((localeParts === null || localeParts === void 0 ? void 0 : localeParts.length) === 2) {
            // case of en-US, fr-FR || fr-CA, fr-AB would be match to fr-FR
            matchingLocale =
                (0, findItem_1.findItem)(eventLocales, 'cultureCode', acceptedLocale) ||
                    (0, findItem_1.findItem)(eventLocales, 'cultureCode', localeParts[0], true) ||
                    null;
        }
        else {
            // case of en, fr || otherwise return default
            matchingLocale = (0, findItem_1.findItem)(eventLocales, 'cultureCode', localeParts === null || localeParts === void 0 ? void 0 : localeParts[0], true) || null;
        }
    }
    return matchingLocale;
};
exports.default = getLocale;
